module.exports = __webpack_public_path__ + "static/media/mustafa.ce75664a.jpeg";